import {Dropdown} from "antd";
import {DownOutlined} from "@ant-design/icons";
import React from "react";
import getMailLinkMenu from "./MailLinkMenu";

export function SubscribeMessage()
{
    return <div style={{textAlign:'center'}}>
        <p>MiAD Wizard lets you customize spec ads in seconds.</p>
        <p>
            To add this to your subscription or for a
            <span style={{color:'red'}}> FREE trial </span>
            please<br/>call 1-800-223-1600 or
            click <Dropdown overlay={getTrialRequestMenu()}>
            <a onClick={e => e.preventDefault()}>
                HERE<DownOutlined />
            </a>
        </Dropdown>
        </p>
    </div>
}

const getTrialRequestMenu = textQuery => getMailLinkMenu({
    subject:"Wizard Trial Request",
    to:"service@metro-email.com",
    body:"Yes!  I want to increase my ad sales right away!  Please call me to set up my FREE trial."
});